import React from 'react';

export default ({ setActiveTab, tabLabel, activeTab }) => (
    <li className={`c-pointer text-uppercase tab-list-item font-weight-bold ${activeTab === tabLabel ? 'active' : ''}`} onClick={() => setActiveTab(tabLabel)}>
        {tabLabel}
    </li>
);
